import { render, staticRenderFns } from "./ReturnDetailModal.vue?vue&type=template&id=fb819642"
import script from "./ReturnDetailModal.vue?vue&type=script&lang=js"
export * from "./ReturnDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports